@if (form) {
    <div [formGroup]="form">
        <sirius-input
            [id]="id"
            [name]="name"
            [label]="label"
            [type]="type"
            [formControlName]="name"
            [identifier]="identifier"></sirius-input>
    </div>
}
